import React, { useState } from "react";

const BankCard = () => {
  const [cardNumber, setCardNumber] = useState("5282 3456 7890 1289");
  const [expiryDate, setExpiryDate] = useState("09/25");
  const [balance, setBalance] = useState("$5,750.20");

  return (
    <div className="flex flex-wrap gap-8 justify-center items-center">
      {/* Main Card */}
      <div className="w-96 h-56 rounded-xl p-6 relative shadow-lg text-white bg-gradient-to-br from-purple-600 via-blue-500 to-indigo-600">
        <div className="flex justify-between items-center mb-8">
          <div className="text-sm opacity-80">Current Balance</div>
          <div className="text-sm font-semibold">MasterCard</div>
        </div>
        <div className="text-2xl font-bold mb-4">{balance}</div>
        <div className="flex justify-between items-center text-lg">
          <div className="font-mono">{cardNumber}</div>
          <div>{expiryDate}</div>
        </div>
      </div>

      {/* Small Card */}
      <div className="w-48 h-56 rounded-xl p-4 relative shadow-md text-white bg-gradient-to-br from-purple-600 via-blue-500 to-indigo-600">
        <div className="flex justify-between items-center mb-4">
          <div className="text-sm opacity-80">Credit Card</div>
          <div className="w-8 h-8 bg-white bg-opacity-20 rounded-full"></div>
        </div>
        <div className="text-xl font-mono mb-2">●●●● 1289</div>
        <div className="text-sm">{expiryDate}</div>
      </div>
    </div>
  );
};

export default BankCard;
